import './Pdftoexcel.css'; 

let Pdftoexcel=()=>{ 
    // let inputhandlechange=async(e)=>{
    //     let file = e.target.files[0];
    //     let inputfile = new FormData();
    //     inputfile.append('pdffile', file);
    //     document.querySelector(".uploadcont").style.display="none";
    //     setprocessing("Please wait while its Converting...");
    //     document.querySelector(".loading").style.display="block";

    //     let res = await api.post('http://localhost/converters/convertpdftoexcel.php', inputfile); 
    //     setdownlaodlink(res.data.downloadUrl);
    //     document.querySelector(".loading").style.display="none";
    //     document.querySelector(".sucmsg").innerHTML = res.data.Status;
    //     document.querySelector(".sucmsg").style.display="block";

        

        
        
        

    // }
    return(
        <div className='pdftoexcel'>
            <p className='heading'>Convert pdf to Excel</p>
            <p style={{display:"none", textAlign:"center"
            }} className='sucmsg'></p> 
            {/* <a href={link}>Downaload</a>     */}
            <div className='uploadcont'>
                <label onClick={()=>{alert("This service available soon...")}} className='inplab' htmlFor='inp'>Choose pdf File</label>
               <input accept='application/pdf' id='inpp' style={{display:"none"}} type='file'/>
            </div>
        </div>
    );  
}
export default Pdftoexcel;